import { NgModule } from '@angular/core';
import { ApiHelper, ArrayHelper, CBU, CheckHelpers, DateHelper, DomHelper, HomeUrlHelper, SecurityHelper } from './helpers';
import { AnalyticsService, AuthGuardService, BypassService, DownloadService, ImpersonationGuardService } from './services';
import { EnvironmentGuard } from './services/environment-guard';

@NgModule({
    providers: [
        // Global Helpers
        ApiHelper,
        DomHelper,
        CBU,
        CheckHelpers,
        ArrayHelper,
        DateHelper,
        SecurityHelper,
        // Global Services
        BypassService,
        AuthGuardService,
        AnalyticsService,
        HomeUrlHelper,
        DownloadService,
        ImpersonationGuardService,
        EnvironmentGuard
    ],
})
export class CoreModule {
}
